<div class="canvas-modal-body flex flex-col flex-1">
  <div class="flex items-center mb-4 justify-end">
    <div class="flex-1">
      <ng-content select="[title]"></ng-content>
      <span class="text-lg font-bold" *ngIf="!customTitle">{{ title }}</span>
    </div>
    <label class="cursor-pointer" (click)="onClose.emit()">✕</label>
  </div>
  <hr class="mb-8" *ngIf="showTitleDivider" />
  <div class="canvas-modal-content flex-1">
    <ng-content></ng-content>
  </div>
</div>
